"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uiBucketDef = void 0;
exports.uiBucketDef = {
    v3: {
        bucketName: 'ui-version-3',
        fwRelativeBase: '../v020',
        uipath: './UIv3',
    },
    v4: {
        bucketName: 'ui-version-4',
        fwRelativeBase: '../v020',
        uipath: './UIv3',
    },
};
// v2: {
//   bucketName: 'ui-version-2',
//   fwRelativeBase: '../v020',
//   uipath: './UI',
// },
